import Observer from '@scripts/components/concerns/Observer';

/**
 * Observable component
 */
export default class {
  /**
   * @private
   *
   * @type {Array<Observer>}
   */
  #observers = [];

  /**
   * Add an observer
   *
   * @param {Observer} observer
   *
   * @return {void}
   */
  subscribe(observer) {
    this.#observers.push(observer);
  }

  /**
   * Remove an observer
   *
   * @param {Observer} observer
   *
   * @return {void}
   */
  unsubscribe(observer) {
    const removeIndex = this.#observers.findIndex((obs) => observer === obs);
    if (removeIndex > -1) {
      this.#observers.splice(removeIndex, 1);
    }
  }

  /**
   * Notify all observers
   *
   * @param {mixed} data Data to pass to the observers
   *
   * @return {void}
   */
  notify(data) {
    this.#observers.forEach((observer) => observer.update(data));
  }
}
